import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <p class="mb-3">
      La patro malkontentas. 
      Li revenadas hejmen deprimita; kaj se li estas malĝoja, do ploru mi kaj la fratinoj. 
      Li diras: “Sekeco, malpluvas”. 
      Li estas impostkolektisto, sed kamparanoj ĉi-jare ne havas per kio pagi impostojn: ĉio forsekiĝis. 
    </p>

    <p class="mb-3">
      Mi ja mem vidas: nia rivero tiel malprofundiĝis, ke por plenigi la kruĉon, oni devas stari klinite ĝis kiam la gamboj ekdoloros; sed antaŭe la rivero mem plenigadis ĝin en palpebruma daŭro… 
    </p>
    
    <p class="mb-3">
      Li diras: 
      “Maizo ne sprosis, vilaĝanoj ne havas kion manĝi; kaj ankaŭ ni baldaŭ ne havos. 
      Sed se mi ne kolektos la impostojn, pereos ne nur vilaĝanoj, pereos la ŝtato mem, ĉio ruiniĝos kaj ŝakaloj kuros laŭ la malplenaj stratoj”.
    </p>
    
    <p class="mb-3">
      Mi timas ŝakalojn, kaj mi ne volas morti pro malsato. Mi estas nur 15-jara, kaj mi volas vivi. 
      Mi ja tiom multe ne vidis ankoraŭ en la vivo!
    </p>
    
    <p class="text-center mb-3">* * *</p>

    <p class="mb-3">
      La rivero nun preskaŭ tute sekiĝis; de la kampoj blovas varmega vento plena de polvo. 
      Ĝi bruligas, malklarigas okulojn, skrapas vizaĝon… 
      La patrino jam ne balaas en la domo: la polvo troviĝas ĉie, kaj ni senfortas batali kontraŭ ĝi, ĉar ĝi aperas denove kaj denove. 
      Ni manĝas preskaŭ sekan maizon kun polvo. 
      Necesas pluvo…
    </p>

    <p class="text-center mb-3">* * *</p>

    <p class="mb-3">
      Hodiaŭ la patro revenis aparte maltrankvila; li forpelis nin fratinojn el la domo, longe priparolis ion kun la panjo, kriis… 
      Ŝi foriris postplora kaj longe observis nin, speciale min. 
      Ĉu oni decidis edzinigi min? 
      Do kial plori – mi ja ekhavos novan vivon, kaj eble, en la domo de la edzo troviĝos pli multe da akvo kaj manĝo? 
      Kaj la gepatroj liberiĝos de unu manĝanto: ja da ni, fratinoj, estas sesopo!
    </p>

    <p class="text-center mb-3">* * *</p>

    <p class="mb-3">
      Mortis Itza, la plej juna fratino. 
      Ŝi magriĝis, nigriĝis kaj poiomete velkis. 
      Ŝi konstante petis trinki; sed ne ekzistas loko, kie ni prenus akvon. 
      Eĉ la plej profundaj putoj sekiĝis. 
      Nun de tie oni prenas nur ŝlimon kaj koton. 
      Se tiaĵon rapide alporti hejmen kaj elpremi tra ĉifonon, rezultiĝos iom da fetora bruna akvo; sed alia akvo forestas.
    </p>

    <p class="mb-3">
      La urbo senhomiĝis: multaj mortas, la plimulto simple ne havas fortojn por foriri el hejmo. 
      La patro jam kelkajn tagojn ne plu veturas al vilaĝoj; li diris, ke tie, en kamparo, jam neniuj restis. 
      Tie forestas lokoj por ŝirmi onin de la suno, kaj la kampoj jam tute kovriĝis per polvo. 
      Nun la patro vizitas la kunsidojn de la Konsilio, sed pri tio, kion ili diskutas tie, rakontas nenion. 
      La patrino apenaŭ moviĝas, kaj tre dankas min, ke mi, kiel la plej aĝa, helpas en la mastrumado, eliras por porti akvon… 
      Sed varmegas, kaj dum oni alportas hejmen peceton da ŝlimo, ĝi ofte sekiĝas…
    </p>

    <p class="text-center mb-3">* * *</p>

    <p class="mb-3">
      Hodiaŭ la patro revenis frue kaj tuj vokis min. 
      Mi komprenis, ke li volas diri ion gravan kaj ekĝojis: fin-fine edziniĝen, al nova vivo! Sed li diris: 
      “Filinjo, vi ricevos la plej ravan edzon, diecan edzon. 
      Vi estas elektita fianĉino de Vitzliputzli-Huitzlipoĉtli, la dio de la pluvo! 
      Milnombraj junulinoj envios vin, kiam vi, vestita brile, ornamita per juveloj, enpaŝos lian regnon! 
      Feliĉu, ĉar vi estas elektita por savi nian popolon!”
    </p>

    <p class="mb-3">
      Mi stuporis. Do jen kiun edzon oni antaŭdestinas al mi! 
      Jes, solene paradi en pompaj vestaĵoj antaŭ la tuta popolo, por ke ĉiuj aplaŭdu min, min adoru, min kultu… 
      Kaj fariĝi fianĉino de grandioza dio, kiu tiel facile povas sendi la morton al la tuta nia popolo; savi la popolon kaj mem fariĝi egala al dioj… 
    </p>

    <p class="mb-3">
      Sed por kio tio al mi? Mi ne deziras splendajn vestojn kaj riĉaĵon; mi neniam revis pri juveloj kaj pri gloro! 
      Mi ŝatas sunon kaj venton, riveron kaj salikojn apud ĝi. 
      Mi volas vivi sur la tero, sed ne sub la tero aŭ surĉiele. 
    </p>

    <p class="mb-3">
      Se Vitzliputzli mortigas homojn, mi ne volas esti lia edzino!
    </p>

    <p class="mb-3">
      Ja ne la unuan fojon venas al ni senpluveco, ne la unuan fojon oni kolektas junulinojn por oferi ilin al li – kaj kio? 
      Ĉu li satiĝis? 
      Ĉu li ĉesis mortigi? 
    </p>

    <p class="mb-3">
      Por li ja tio ne gravas: li daŭre voras junulinojn, mortigas homojn kaj ĝenerale ne atentas iliajn agojn! 
      Kiomfoje post oferdono ne okazis pluvo! La patro rakontis, ke foje pluvas ĵus antaŭ la planita ceremonio; tiam la riton oni rapide abolas, kaj la elektitaj junulinoj revenas al siaj familioj. 
      Sed ilin neniu edzinigas, ĉar la dio mem ne volis akcepti ilin; kiu do bezonus ilin ĉi tie? 
      Ili kadukiĝas kaj mortas en soleco, oni forpelas ilin el hejmoj kaj neniu manĝigas ilin. 
      Kaj se ne pluvis longe post la rito, nenio okazis. 
      La pastroj ne hontis, ke ili eraris. 
      Ili senĝene daŭrigis plu preskribi la ritojn kaj elekti oferojn… 
      Ĉu la Distingindajn? Ne, oferojn, kaj mi ne volas esti ofero!
    </p>

    <p class="mb-3">
      Sed kiu demandos junulinon, ĉu ŝi volas aŭ ne volas esti la Distinginda, fianĉino, ofero? 
      Ŝia afero estas obei kaj ĝoji pro ĉio, kion oni preskribos al ŝi sur la vivovojo. 
      Ŝi ne estas homo, ŝi estas ŝanĝmonero, per kiu oni pagas … al kiu? 
      Al dio, kiu estigas malbonon? 
      Aŭ al sia propra timo antaŭ tiu dio, antaŭ ĉiuj dioj, nevideblaj kaj nekompreneblaj, kiuj regas en tiu nekomprenebla al ni mondo? 
    </p>

    <p class="mb-3">
      La pastroj okazigas ritojn, kiuj influas nenion; sed neniu rimarkas tion, ĉiuj senpense kredas al pastroj, ĉar la mondo estas grandega kaj nekonata. 
      Sed necesas ja ajna orientilo, iu ajn apogilo, io kion eblas kredi! 
      Nu jen, ekzemple, kredi, ke la mortigo de junulinoj utilos al la sorto de la popolo… 
      Sed al kiuj utilos la vivoj de tiuj junulinoj? Ili neniom valoras. 
      Tamen, espereble, Vitzliputzli ekkompatos la popolon…
    </p>

    <p class="mb-3">
      Nur la pastroj estas senkompataj. 
      Estas ili, kiuj elektas fianĉinojn por la dio; sed de kie ili scias, kiun deziras tiu dio? 
      Ĉu vere li deziras ĝuste min, kiu tiel malamas lin, semanton de malbono? 
      Mi ne havas eblon saviĝi, sed mi rezistos ĝisfine. 
      Mi ne cedos humile al la morto. 
    </p>

    <p class="text-center mb-3">* * *</p>

    <p class="mb-3">
      Nenio povis nuligi la proklamitan ceremonion: ja ne ekpluvis intertempe. 
      En la indikita tago la solena procesio sin direktis al la Granda Senoto. 
      La belaj knabinoj, filinoj de elitaj familioj, plej indaj de la urbo, kronitaj per diademoj, kovritaj per oro kaj juveloj brilantaj sur iliaj vestaĵoj sub radioj de senkompata suno, estis renkontitaj de aplaŭdegoj de l’ popolo, revivigita de l’ espero. 
      Sur la vizaĝoj de junulinoj vidiĝis la sama ekzaltiĝo: ili ja estas elektitaj por savo de la popolo; ilia memofero alportos vivon al sekiĝintaj kampoj, al mortantaj familioj. 
      Kaj kiel belege estas stari tiel, majeste vestitaj, sub ravaj rigardoj kaj jubilaj krioj de l’ amaso! 
      Por tio ne indus domaĝi sian vivon. 
      Kion vidis tiuj knabinoj en siaj hejmoj? 
      Muelŝtonojn por maizo kaj pedikojn? 
      Kaj jen venis la plej glora tago de ilia vivo! 
    </p>

    <p class="mb-3">
      La procesio alproksimiĝis al la Senoto, kaj la pastroj komencis ĵetadi po unu la brilantajn juninojn al la faŭko de la puto. 
      La krioj de la knabinoj kunsonis kun jubilaj krioj de l’ homamaso. 
      Sed subite unu el junulinoj rapide elturniĝis el la vico, ĉirkaŭbrakumis la plej proksiman al ŝi pastron kaj kune kun li sin ĵetis al faŭkanta abismo. 
    </p>

    <p class="mb-3">
      La ceremonio daŭris. 
      Nenio rajtas rompi la grandan riton de l’ komunikiĝo kun la dio. 
    </p>

    <p class="mb-5">
      Kaj la sekvan tagon ekpluvis.
    </p>

    <ol class="cites mb-3">
      <li>
        “Götter, Gräber und Gelehrte”, C. W. Ceram: <br/>
        “Inter multnombraj kranioj de junulinoj, suprenigitaj el la Sankta Senoto, estis trovita unusola kranio de maljuna viro”.
      </li>
      <li>
        La nomo de la pluvdio de majaoj estas ne Vitzliputzli-Huitzlipoĉtli, sed Ĉack. 
        Sed tio sonas tro prozece, kaj krome, koincidas kun la nomo de fama esperantisto. 
        Sed ni ne bezonas tiajn tiklaĵojn!:-) <br/> 
        Vitzliputzli-Huitzlipoĉtli estas la militdio de aztekoj. 
      </li>
      <li>
        Kaj ŝakaloj ne loĝas en Sudameriko; sed kiu besto, konata al vasta publiko, samtempe abomena kaj minaca, povus celdirekte influi la mensojn de legantoj?
      </li>
    </ol>
    `
  )
}

const itemName = {
  esp: 'Junilino el Ĉiĉen-Itca'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;